import React from 'react';
import { useSlotPlaceholder, withSlotsPlaceholders } from '@wix/widget-plugins-ooi';
import { ABOVE_HEADER } from '@app/constants/ooi-slots';
import PermissionsProvider from '@app/external/common/components/permissions-provider';
import ResponsiveListener from '@app/external/common/components/responsive-listener/responsive-listener';
import { withRootProps } from '@app/external/common/components/root-props/with-root-props';
import { useSelector } from '@app/external/common/components/runtime-context';
import { withReduxStore } from '@app/external/common/components/runtime-context/with-redux-store';
import WindowResizeListener from '@app/external/common/components/window-resize-listener';
import { usePinterestInit } from '@app/external/common/hooks/use-pinterest-init';
import {
  useBlogNotifications,
  usePostPushNotifications,
} from '@app/external/common/hooks/use-ws-notifications';
import { getIsCreatedWithResponsiveEditor } from '@app/external/common/selectors/app-settings-selectors';
import { isEditor as getIsEditor } from '@app/external/common/store/basic-params/basic-params-selectors';
import Router from '../router';
import styles from './app-root.scss';

function AppRoot() {
  const [AboveHeaderSlotsPlaceholder, isAboveHeaderSlotEmpty] = useSlotPlaceholder(ABOVE_HEADER);

  const isInClassicEditor = useSelector(
    (state) => getIsEditor(state) && !getIsCreatedWithResponsiveEditor(state),
  );

  usePinterestInit();
  useBlogNotifications();
  usePostPushNotifications();

  return (
    <ResponsiveListener dataHook="post-page-root" className={styles.root}>
      <PermissionsProvider>
        <>
          <div className={!isAboveHeaderSlotEmpty ? styles.aboveHeaderSlot : ''}>
            <AboveHeaderSlotsPlaceholder />
          </div>
          <Router />
          {isInClassicEditor && <WindowResizeListener />}
        </>
      </PermissionsProvider>
    </ResponsiveListener>
  );
}

export default withSlotsPlaceholders(withRootProps(withReduxStore(AppRoot)));
